<template lang="html">
    <ModalDefault size="s" :with-content="true" @close="close();" :theme="true" :fix-height="false" :fix-width="false" :loading="false">
        <template slot="main">
            <div class="row d-flex align-items-center">
                <div class="col-auto">
                    <ClientColorButton size="m" :rounded100="true" background-color="#F9C53C" color="#fff">
                        <i class="fa fa-undo-alt fa-lg"></i>
                    </ClientColorButton>
                </div>
                <div class="col">
                    <p class="title mb-0">{{ params.periodHasZone.zone.name.toUpperCase() }} {{ $t("catalogForecast.market.wasRechallenged") }}</p>
                    <span class="subtitle">{{
                        $t("catalogForecast.market.rechallengedByOn", {
                            user: params.periodHasZone.lastRechallenge.by.firstname + " " + params.periodHasZone.lastRechallenge.by.lastname,
                            month: moment(params.periodHasZone.lastRechallenge.date).format("MM"),
                            monthText: moment(params.periodHasZone.lastRechallenge.date).format("MMMM"),
                            dayth: moment(params.periodHasZone.lastRechallenge.date).format("Do"),
                            day: moment(params.periodHasZone.lastRechallenge.date).format("DD")
                        })
                    }}</span>
                </div>
            </div>

            <div class="mt-5">
                <p class="message-label m-0 mb-2">{{ $t("catalogForecast.market.messageLabel") }}</p>
                <div class="message" v-html-safe="params.periodHasZone.lastRechallenge.message.replaceAll('\n', '<br>')"></div>
                <p class="message-message m-0 mt-2">{{ $t("catalogForecast.market.accessMessage") }}</p>
            </div>

            <div class="row">
                <div class="col d-flex justify-content-end mt-5">
                    <ClientColorButton :inactiveColor="true" @click="close"> {{ $t("common.ok") }} </ClientColorButton>
                </div>
            </div>
        </template>
    </ModalDefault>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import * as moment from "moment/moment";

export default {
    components: {DefaultTextareaInputBloc, ModalDefault},
    props: ['params'],
    data () {
        return {
            moment
        }
    },
    methods: {
        close() {
            this.params.isActive = false;
            this.$emit('close');
        }
    },
}
</script>

<style scoped lang="scss">
.title {
    font-family: Roboto;
    font-weight: bold;
    font-size: 20px;
}
.subtitle {
    font-size: 20px;
    text-transform: initial;
}
.message-label {
    color: #ffca39;
    font-size: 20px;
    font-weight: bold;
}
.message {
    height: 156px;
    overflow: auto;
    padding: 5px 15px;
    border: 1px solid #aaa;
    background-color: #eee;
}
.message-message {
    color: #ffca39;
    font-size: 12px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// RechallengeInfos.vue?68d6b92d